import api from './client'

export const tablasApi = {
  listar:    ()              => api.get('/sistema/tablas'),
  ver:       (tabla, params) => api.get(`/sistema/tablas/${tabla}`, { params }),
  consultar: (sql)           => api.post('/sistema/tablas/consultar', { sql }),
}
